import { useContext } from 'react';
// Import the context itself (adjust path if AuthContext.jsx is moved)
import { AuthContext } from '../context/AuthContext'; 

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
      throw new Error('useAuth must be used within an AuthProvider');
  }
  // Return the whole context value provided by AuthProvider
  // which includes { session, user, loading, login, logout, register }
  return context;
};

// Remove all the old localStorage logic and mutation setup
